export default (content) => {
    return {
        content: [content],
        empty: false,
        first: false,
        last: false,
        number: 0,
        numberOfElements: 0,
        pageable: {
            offset: 0,
            pageNumber: 0,
            pageSize: 0,
            paged: true,
            sort: {
                empty: false,
                sorted: false,
                unsorted: true
            },
            unpaged: true
        },
        sort: {
            empty: false,
            sorted: false,
            unsorted: true
        },
        size: 0,
        totalElements: 0,
        totalPages: 0
    };
};
//# sourceMappingURL=asPagedContent.js.map